import { motion } from 'framer-motion'

const Introduction = () => {
  return (
    <section className="relative py-16 md:py-24">
      <div className="relative z-[2] max-w-2xl mx-auto px-6 text-center">
        <motion.p
          className="font-display text-cream-200 text-xl md:text-2xl lg:text-3xl leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 1, ease: 'easeOut' }}
        >
          An integrated care clinic at Yonge &amp; Eglinton, combining massage
          therapy, movement-based care, and wellness support to help you feel{' '}
          <em className="italic">supported, informed</em>, and more in control of
          your body.
        </motion.p>
      </div>
    </section>
  )
}

export default Introduction
